import { motion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

export default function Manifesto() {
  const words = "We are your voice.".split(" ");
  return (
    <section data-testid="manifesto-section" className="relative py-28 md:py-40 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p
          variants={reveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="text-xs uppercase tracking-[0.3em] text-hero-red mb-10"
        >
          — The Middle Ground
        </motion.p>

        <h2 className="font-display uppercase leading-[0.95] text-4xl sm:text-6xl lg:text-7xl max-w-5xl">
          <motion.span
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="block text-white/90"
          >
            We stand between you
          </motion.span>
          <motion.span
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: 0.12 }}
            className="block text-white/40"
          >
            and the insurance company.
          </motion.span>
          <span className="block mt-2">
            {words.map((w, i) => (
              <motion.span
                key={i}
                variants={reveal}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, delay: 0.3 + i * 0.1 }}
                className="inline-block text-hero-red mr-4"
              >
                {w}
              </motion.span>
            ))}
          </span>
        </h2>

        <motion.p
          variants={reveal}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-10 max-w-2xl text-lg text-hero-silver"
        >
          You pay the deductible from your homeowner&apos;s book — or your landlord does. Once the insurance company pays the rest, you get a brand-new roof. That&apos;s the whole deal, and we make it simple.
        </motion.p>
      </div>
    </section>
  );
}
